import { Injectable } from '@angular/core'
import { UrlTree } from '@angular/router'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import { GbAuctionHomeUrlService } from 'libs/gb-front/auction/util/src/lib/gb-auction-home-url-service/gb-auction-home-url.service'
import { Observable, of, switchMap } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class CategoryGuard {
  hasCategoryWithItems$ = this.auctionFacade.hasCategoryWithItems$
  homeUrlTree$ = this.gbAuctionHomeUrlService.homeUrlTree$

  constructor(private gbAuctionHomeUrlService: GbAuctionHomeUrlService, private auctionFacade: AuctionFacade) {}

  /**
   * Allow access to category route if auction has one or more
   * categories with items, otherwise redirect to home route
   */
  canActivate(): Observable<boolean | UrlTree> {
    return this.hasCategoryWithItems$.pipe(
      switchMap((hasCategoryWithItems) => (hasCategoryWithItems ? of(true) : this.homeUrlTree$)),
    )
  }
}
